var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 31,
    viewBox: "0 0 47 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7048 8.39364C37.3638 7.12338 36.3593 6.12301 35.0834 5.78351C32.7715 5.1665 23.4999 5.1665 23.4999 5.1665C23.4999 5.1665 14.2285 5.1665 11.9164 5.78351C10.6406 6.12301 9.63579 7.12338 9.29504 8.39364C8.67558 10.696 8.67558 15.4999 8.67558 15.4999C8.67558 15.4999 8.67558 20.3035 9.29504 22.6062C9.63579 23.8765 10.6406 24.8767 11.9163 25.2165C14.2284 25.8333 23.4998 25.8333 23.4998 25.8333C23.4998 25.8333 32.7713 25.8333 35.0833 25.2165C36.3591 24.8768 37.3637 23.8765 37.7047 22.6063C38.3243 20.3037 38.3243 15.5 38.3243 15.5C38.3243 15.5 38.3243 10.6961 37.7047 8.39376",
    fill: "#7E8A94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4677 19.8617L28.2167 15.5004L20.4677 11.1387V19.8617Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.88d35f06a94212af5ffdee1deec73cf2.svg";
export { ForwardRef as ReactComponent };